import { HttpError } from '@octopus-do/octopus-api-client'

export const isAuthError = (err: unknown) =>
  err instanceof HttpError && err.status === 401
